import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { loginRoute } from '../../core/config/routes.config';
import { deleteSession } from '../../core/services/storage.service';
import { TranslationService } from '../../core/services/translation.service';
import { APP_TITLE_KEY } from '../../dashboard/dashboard.component';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private translationService: TranslationService,
    private titlesService: Title
  ) { }

  ngOnInit() {
    deleteSession();
    this.router.navigateByUrl(loginRoute);
    const title = this.translationService.getTranslationSync(APP_TITLE_KEY);
    this.titlesService.setTitle(title);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/logout/logout.component.ts